import { render, staticRenderFns } from "./VTextareaPublic.vue?vue&type=template&id=3bce2070"
import script from "./VTextareaPublic.vue?vue&type=script&lang=js"
export * from "./VTextareaPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports